import Registry from 'registry';
import { initializeFirebase } from '../firebase';

import { LOGIN_SUCCESS, SET_CURRENT_USER } from "../reducers/currentUser";

const firebaseMiddleware = (store) => (next) => (action) => {
    const config = Registry.get('FIREBASE_CREDENTIALS');
    if (action.type === LOGIN_SUCCESS || action.type === SET_CURRENT_USER) {
        initializeFirebase(config);
    }
    next(action);
};

export default firebaseMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/firebaseMiddleware.js